import React, { useState } from "react";
import styled from "styled-components";
import { motion } from "framer-motion";

const Contact = () => {
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    service: "",
    message: "",
  });
  const handleChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });

  const services = [
    "Pastrim i Thellë Profesional",
    "HydraFacial",
    "Dermapen (Microneedling)",
    "Peeling Kimik",
    "Ultra Contour Touch Vecom",
    "Body Combo 10 Vecom",
    "Maderoterapia",
    "VF 100",
    "Konsultë",
  ];

  return (
    <Section id="contact">
      <Inner>
        <LeftPanel>
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.9 }}
          >
            <Label>Rezervo Vizitën</Label>
            <Title>
              Start Your
              <br />
              <em>Journey</em>
            </Title>
            <Tagline>
              Na kontaktoni dhe le të dizajnojmë protokollin tuaj të përsosur të
              trajtimit bashkë.
            </Tagline>
          </motion.div>

          <ContactDetails>
            {[
              {
                icon: "◎",
                label: "Adresa",
                val: "Rruga B te spari - Prishtinë",
              },
              {
                icon: "◉",
                label: "Telefon",
                val: "+383 45 885 301",
              },
              {
                icon: "◈",
                label: "Email",
                val: "elaia.aesthetic@gmail.com",
              },
              { icon: "◇", label: "Orari", val: "Hën–Sht: 09:00 – 19:00" },
            ].map((d, i) => (
              <DetailRow
                key={d.label}
                as={motion.div}
                initial={{ opacity: 0, x: -30 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: i * 0.1 }}
              >
                <DetailIcon>{d.icon}</DetailIcon>
                <div>
                  <DetailLabel>{d.label}</DetailLabel>
                  <DetailVal>{d.val}</DetailVal>
                </div>
              </DetailRow>
            ))}
          </ContactDetails>
        </LeftPanel>

        <FormPanel
          as={motion.div}
          initial={{ opacity: 0, x: 60 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
        >
          <FormTitle>Kërko një Takim</FormTitle>
          <Form onSubmit={(e) => e.preventDefault()}>
            <Row>
              <Field>
                <FieldLabel>Emri i Plotë</FieldLabel>
                <Input
                  name="name"
                  value={form.name}
                  onChange={handleChange}
                  placeholder="Emri juaj"
                />
              </Field>
              <Field>
                <FieldLabel>Adresa Email</FieldLabel>
                <Input
                  name="email"
                  type="email"
                  value={form.email}
                  onChange={handleChange}
                  placeholder="email@juaj.com"
                />
              </Field>
            </Row>
            <Row>
              <Field>
                <FieldLabel>Numri i Telefonit</FieldLabel>
                <Input
                  name="phone"
                  value={form.phone}
                  onChange={handleChange}
                  placeholder="+383 ..."
                />
              </Field>
              <Field>
                <FieldLabel>Trajtimi i Dëshiruar</FieldLabel>
                <Select
                  name="service"
                  value={form.service}
                  onChange={handleChange}
                >
                  <option value="">Zgjidhni një shërbim</option>
                  {services.map((s) => (
                    <option key={s} value={s}>
                      {s}
                    </option>
                  ))}
                </Select>
              </Field>
            </Row>
            <Field>
              <FieldLabel>Mesazhi (Opsional)</FieldLabel>
              <Textarea
                name="message"
                value={form.message}
                onChange={handleChange}
                placeholder="Na tregoni për shqetësimet ose qëllimet tuaja të lëkurës..."
                rows={5}
              />
            </Field>
            <SubmitBtn
              as={motion.button}
              type="submit"
              whileHover={{ scale: 1.02, backgroundColor: "var(--gold)" }}
              whileTap={{ scale: 0.97 }}
            >
              Dërgo Kërkesën
            </SubmitBtn>
          </Form>
        </FormPanel>
      </Inner>
    </Section>
  );
};

const Section = styled.section`
  background: var(--charcoal-soft);
  padding: 140px 0;
  position: relative;
  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 60px;
    right: 60px;
    height: 1px;
    background: linear-gradient(
      to right,
      transparent,
      rgb(190, 164, 149),
      transparent
    );
  }
`;
const Inner = styled.div`
  max-width: 1300px;
  margin: 0 auto;
  padding: 0 60px;
  display: grid;
  grid-template-columns: 1fr 1.4fr;
  gap: 100px;
  align-items: start;
  @media (max-width: 1024px) {
    grid-template-columns: 1fr;
    gap: 60px;
  }
  @media (max-width: 768px) {
    padding: 0 24px;
  }
`;
const LeftPanel = styled.div`
  position: sticky;
  top: 120px;
  @media (max-width: 1024px) {
    position: relative;
    top: auto;
  }
`;
const Label = styled.span`
  display: block;
  font-family: var(--font-body);
  font-size: 11px;
  font-weight: 400;
  letter-spacing: 0.3em;
  text-transform: uppercase;
  color: var(--rose);
  margin-bottom: 20px;
`;
const Title = styled.h2`
  font-family: var(--font-display);
  font-size: clamp(44px, 5.5vw, 80px);
  font-weight: 300;
  color: var(--cream);
  letter-spacing: -0.02em;
  line-height: 1.05;
  margin: 0 0 20px;
  em {
    font-style: italic;
    color: var(--rose);
  }
`;
const Tagline = styled.p`
  font-family: var(--font-body);
  font-size: 15px;
  color: var(--taupe);
  line-height: 1.8;
  margin: 0 0 52px;
`;
const ContactDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;
const DetailRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 20px;
  padding: 20px 0;
  border-bottom: 1px solid rgba(196, 149, 122, 0.1);
  &:last-child {
    border-bottom: none;
  }
`;
const DetailIcon = styled.span`
  font-size: 18px;
  color: var(--rose);
  opacity: 0.7;
  flex-shrink: 0;
  margin-top: 2px;
`;
const DetailLabel = styled.div`
  font-family: var(--font-body);
  font-size: 10px;
  font-weight: 400;
  letter-spacing: 0.2em;
  text-transform: uppercase;
  color: var(--rose);
  margin-bottom: 4px;
`;
const DetailVal = styled.div`
  font-family: var(--font-body);
  font-size: 14px;
  color: var(--cream);
  opacity: 0.8;
`;
const FormPanel = styled.div`
  background: rgba(231, 224, 218, 0.5);
  border: 1px solid rgba(196, 149, 122, 0.1);
  padding: 56px 52px;
  @media (max-width: 768px) {
    padding: 36px 24px;
  }
`;
const FormTitle = styled.h3`
  font-family: var(--font-display);
  font-size: clamp(22px, 2.5vw, 30px);
  font-weight: 400;
  color: var(--cream);
  margin: 0 0 40px;
`;
const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;
const Row = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;
const Field = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;
const FieldLabel = styled.label`
  font-family: var(--font-body);
  font-size: 11px;
  font-weight: 400;
  letter-spacing: 0.15em;
  text-transform: uppercase;
  color: var(--taupe);
`;
const inputBase = `background: rgba(207,181,155,0.6); border: 1px solid rgba(196,149,122,0.15); color: var(--cream); font-family: var(--font-body); font-size: 14px; font-weight: 300; padding: 14px 18px; outline: none; transition: border-color 0.3s; width: 100%; box-sizing: border-box; &:focus { border-color: rgba(196,149,122,0.5); } &::placeholder { color: rgba(138,125,115,0.5); }`;
const Input = styled.input`
  ${inputBase}
`;
const Select = styled.select`
  ${inputBase} cursor: pointer;
  appearance: none;
  option {
    background: var(--charcoal);
  }
`;
const Textarea = styled.textarea`
  ${inputBase} resize: vertical;
  min-height: 120px;
`;
const SubmitBtn = styled.button`
  align-self: flex-start;
  color: var(--charcoal);
  background: var(--rose);
  font-family: var(--font-body);
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0.2em;
  text-transform: uppercase;
  padding: 18px 52px;
  border: none;
  cursor: pointer;
  transition: background 0.3s;
`;

export default Contact;
